import { MIMETYPE_XLSX } from 'cadenza/model/media-type';

import { AbstractTableExportAction } from './abstract-table-export-action';
import i18n from './export-to-xlsx-action.properties';

export class ExportToXlsxAction extends AbstractTableExportAction {

  constructor (options = {}) {
    super(
      MIMETYPE_XLSX,
      {
        ...options,
        label: i18n('action.label'),
        dialogTitle: i18n('dialog.title')
      });
  }

}
